<template>
  <!-- TEMPLATE -->
  <!-- eslint-disable -->
  <!-- Outer Shell with background settings for non-Outlook clients -->

  <div
    STYLE="background:#ffffff; padding:0px !important;margin:0px !important;width:100% !important;"
    align="center"
    id="eproposal"
  >
    <table width="100%" cellpadding="0" cellspacing="0" border="0">
      <tr>
        <td STYLE="padding:0px;"  valign="top">
          <!-- Inner Shell establishes width -->
          <div STYLE="max-width:610px;">
            <table
              WIDTH="610"
              BGCOLOR="#ffffff"
              cellpadding="0"
              cellspacing="0"
              border="0"
              style="width: 100% !important"
            >
              <tr>
                <td
                  STYLE="padding:0px; border:solid 8px #0065a4"
                  align="center"
                  valign="top"
                >
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr>
                        <td style="padding: 20px">
                          <img
                            src="http://image.directsourcing.info/directsource/clients/2021MarketingEmails/RCIGold_50Years.png"
                            width="160"
                            height="80"
                            alt=""
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          align="left"
                          style="
                            padding: 5px 15px 0px 15px;
                            font-family: arial, helvetica, san-serif;
                            font-size: 14px;
                            color: #647682;
                          "
                        >
                          <div>
                          <p>
                            <span
                              style="
                                font-size: 16px;
                                font-weight: bold;
                                color: #61a60e;
                              "
                              >We are experts in every aspect of Talent
                              Acquisition.
                              <a href="https://www.rciars.com/about-us/"
                                >For 50 years we&rsquo;ve gained knowledge and
                                built solutions that work for our clients.</a
                              ></span
                            ><br />
                          </p>
                          <p>
                            We specialize in finding the right fit for your
                            company’s needs. Beyond that core deliverable, we
                            partner with you on a strategic level and customize
                            a solution specific to your needs, budget, and
                            future.
                            <br />
                          </p>
                          <p>
                            RCI’s exclusive AI-enabled TalentLocator solution
                            searches by skill set, experience, education, and
                            location (zip code, area code, city, county, or
                            state). Once our sourcing experts locate the
                            candidates, that’s where your various strategies
                            come in.
                            <br />
                            <br />
                            The options below are designed to identify specific
                            individuals who meet your requirements. They cover
                            everything from advertising your job and sourcing
                            quality leads to recruiting and fully vetting
                            qualified candidates in configurations that work for
                            your business.
                          </p>
                          </div>

                         
                          <div v-if="show_as">
                            <table
                              width="100%"
                              border="0"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#0065A4"
                                    style="
                                      font-size: 18px;
                                      color: #fefefe;
                                      padding: 3px;
                                      padding-left: 10px;
                                    "
                                    >
                                    Advertising Support
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            Beginning with a TalentLocator search, we identify
                            all candidates. Then, through various advertising
                            mediums and strategic timing, we consistently reach
                            out to that candidate pool ideal for your needs. We
                            then showcase your position to them. <br />
                            <br />
                            <p>
                              <span
                                style="                                  
                                  background: yellow;
                                  font-weight: bold;
                                  color: #0065a4;
                                  padding: 5px;
                                "
                                >RCI’s TalentLocator Showcase - ${{
                                  as_tl_showcase
                                }} - {{ as_picked.toUpperCase() }}</span
                              ><br />
                              <i
                                >Perfect for teams with the time and ability to
                                handle the inbound response.</i
                              >
                            </p>
                            <table width="389" border="0" cellspacing="2">
                              <tbody>
                                <tr>
                                  <td width="6">&nbsp;</td>
                                  <td width="332">
                                    <b
                                      >• Daily Email Campaign to all qualified
                                      candidates
                                    </b>
                                  </td>
                                </tr>
                                <tr v-if="as_addon_txt>0">
                                  <td>&nbsp;</td>
                                  <td>Add Texts - <span style="
                                  font-size: 14px;
                                  font-weight: bold;                                  
                                "> ${{ as_addon_txt }}</span></td>
                                </tr>
                                <tr v-if="as_addon_call>0">
                                  <td>&nbsp;</td>
                                  <td> Add Phone Calls -
                                   <span style="
                                  font-size: 14px;
                                  font-weight: bold;                                  
                                "> ${{ as_addon_call }} </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            
                            <p>
                              <div
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  color: #0065a4;
                                "
                               v-if="as_premier_post>0" >RCI’s Premier Post - ${{
                                  as_premier_post
                                }}</div>
                              <div
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  color: #0065a4;
                                "
                                v-if="as_perfect_post>0" >RCI’s PerfectPost - ${{
                                  as_perfect_post
                                }}</div>
                              <div
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  color: #0065a4;
                                "
                                v-if="as_video_premier_post>0" >RCI’s Video PremierPost - ${{
                                  as_video_premier_post
                                }}</div
                              >
                              <div
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  color: #0065a4;
                                "
                               v-if="as_video_perfect_post>0" >RCI’s Video PerfectPost - ${{
                                  as_video_perfect_post
                                }}</div
                              >
                              <div
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  color: #0065a4;
                                "
                               v-if="as_addon_perfect_assist>0" >RCI’s PerfectAssist - ${{
                                  as_addon_perfect_assist
                                }}</div>
                              <i
                                >Perfect for job titles with multiple openings
                                in one location (i.e.: retail, restaurant,
                                etc.)</i
                              >
                            </p>
                            <table width="545" border="0" cellspacing="2">
                              <tbody>
                                <tr>
                                  <td>&nbsp;</td>
                                  <td>
                                    <b
                                      >• Blitz advertising campaign via email,
                                      job posting, SEO, and social media</b
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                          </div>

                         
                          <div v-if="show_ss">
                            <table
                              width="100%"
                              border="0"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#00929F"
                                    style="
                                      font-size: 18px;
                                      color: #fefefe;
                                      padding: 3px;
                                      padding-left: 10px;
                                    "
                                  >
                                    Sourcing Support
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            Engaging our TalentLocator engine, we scour
                            thousands of web locations instantly and combine
                            that cutting-edge technology with highly trained
                            sourcing specialists to find virtually every resume
                            relevant to your needs.<br /><br />
                            <p>
                              <span
                                style="                                  
                                  background: yellow;
                                  font-weight: bold;
                                  color: #0065a4;
                                  padding: 5px;
                                "
                                >RCI’s TalentLocator Pipeline - ${{
                                  ss_tl_pipeline
                                }} - {{ ss_picked.toUpperCase() }}</span
                              ><br />
                              <i
                                >Perfect for teams looking to build their
                                candidate pool for now and future needs.</i
                              >
                            </p>
                            <table width="539" border="0" cellspacing="2">
                              <tbody>
                                <tr>
                                  <td width="12">&nbsp;</td>
                                  <td width="491">
                                    <b
                                      >After the initial pool of candidates are
                                      located our screeners assess each of their
                                      resumes. These resumes are then given to
                                      you to keep and use as you see fit.
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td>&nbsp;</td>
                                  <td>
                                    <span
                                      style="
                                        font-size: 14px;
                                        font-weight: bold;
                                        color: #47c3d3;
                                      "
                                      >There is never a placement fee, and that
                                      will never change.</span
                                    ><br />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                          </div>
                          
                          <div v-if="show_rs">
                            <table
                              width="100%"
                              border="0"
                              cellspacing="0"
                              cellpadding="0"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#6CB33F"
                                    style="
                                      font-size: 18px;
                                      color: #fff;
                                      padding: 3px;
                                      padding-left: 10px;
                                    "
                                  >
                                    Recruiting Support
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            Our professional recruiters go to work for you with
                            TalentLocator at the core, utilizing traditional and
                            non-traditional methods for each project, assuring
                            you get the attention and results you need. They
                            call each candidate ensuring they are qualified
                            (skill, location, salary, cultural fit) and
                            interested in your opportunity. Candidates
                            determined to be qualified will be submitted to you
                            directly for you to make the hire(s).<br /><br />
                            <p>
                              <span
                                style="
                                  background: yellow;
                                  font-weight: bold;
                                  padding: 5px;
                                  color: #00447c;
                                "
                                >TL Recruit - ${{ rs_tl_recruit }}
                                 - {{ rs_picked.toUpperCase() }}
                                </span
                              ><br />
                              <i
                                >Perfect for companies with little to no
                                internal recruiting team and varying hiring
                                teams.</i
                              >
                            </p>
                            <table width="554" border="0" cellspacing="2">
                              <tbody>
                                <tr v-if="rs_jit_rpo.length != 0">
                                  <td width="4">&nbsp;</td>
                                  <td width="540">
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                      >• Just-In-Time RPO - ${{ rs_jit_rpo }} -
                                    </span>
                                    is an “as needed” service to provide you the
                                    resources when you need them to find and
                                    hire the best-qualified candidate for you.
                                  </td>
                                </tr>
                                <tr v-if="rs_pb_rpo.length != 0">
                                  <td>&nbsp;</td>
                                  <td>
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                      >• Project-based RPO - ${{ rs_pb_rpo }} -
                                    </span>
                                    is exactly what the name suggests, a
                                    “project-based” service based on your
                                    company’s hiring needs and initiatives.
                                  </td>
                                </tr>
                                <tr v-if="rs_fl_rpo.length != 0">
                                  <td>&nbsp;</td>
                                  <td>
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                      >• Full-Life RPO - ${{ rs_fl_rpo }} -
                                    </span>
                                    is an ongoing service where our team takes
                                    on the entire scope of recruiting for your
                                    company and delivers you from the burden of
                                    responses from unqualified candidates.
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            <p>
                              <span
                                style="
                                  font-size: 14px;
                                  font-weight: bold;
                                  color: #00447c;
                                "
                                >RCI’s Executive Search </span
                              ><br />
                              <i
                                >Perfect for companies that need a dedicated
                                resource to fill jobs and flexible pricing
                                options.</i
                              >
                            </p>
                            <p>
                              A recruiter will be assigned to your position and
                              will work to fill the role using traditional and
                              non-traditional recruiting methods. These
                              partnerships are typically more expensive than our
                              project-based models, but the various pricing
                              breakdowns allow for flexibility.
                            </p>
                            <table width="400" border="0" cellspacing="2">
                              <tbody>
                                <tr  v-if="rs_container_search.length != 0">
                                  <td width="12">
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                      >&nbsp;</span
                                    >
                                  </td>
                                  <td width="378">
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                      >• Contained Search
                                      <span
                                        style="
                                          font-size: 14px;
                                          font-weight: bold;
                                          color: #00447c;
                                        "
                                        >- ${{ rs_container_search }}</span
                                      ></span
                                    >
                                  </td>
                                </tr>
                                <tr v-if="rs_retained_search.length != 0" >
                                  <td>&nbsp;</td>
                                  <td>
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                      >• Retained Search
                                      <span
                                        style="
                                          font-size: 14px;
                                          font-weight: bold;
                                          color: #00447c;
                                        "
                                        >- ${{ rs_retained_search }}</span
                                      ></span
                                    >
                                  </td>
                                </tr>
                                <tr v-if="rs_contingency_search.length != 0">
                                  <td>&nbsp;</td>
                                  <td>
                                    <span
                                      style="color: #00447c; font-weight: bold"
                                       >• Contingency Search<span
                                        style="
                                          font-size: 14px;
                                          font-weight: bold;
                                          color: #00447c;
                                        "
                                      >
                                        - $ {{ rs_contingency_search }}</span
                                      ></span
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <br />
                            <a href="https://www.rciars.com/our-testimonials/">
                              <center>
                                Please check out some of our client
                                testimonials!
                              </center>
                            </a>
                            <br />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody></tbody>
                  </table>
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr>
                        <td align="center" style="padding-bottom: 15px">
                          <table
                            width="150"
                            border="0"
                            cellspacing="0"
                            cellpadding="0"
                          >
                            <tbody>
                              <tr>
                                <td
                                  align="center"
                                  bgcolor="#0066a4"
                                  style="
                                    font-family: arial, helvetica, san-serif;
                                    font-size: 14px;
                                    padding: 5px;
                                  "
                                >
                                  <a
                                    href="http://www.rciars.com/talentlocator"
                                    style="
                                      color: #ffffff;
                                      text-decoration: none;
                                    "
                                    >FIND OUT MORE</a
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          bgcolor="#000000"
                          style="
                            font-family: arial, helvetica, san-serif;
                            font-size: 14px;
                            color: #ffffff;
                            padding: 30px 0px;
                          "
                        >
                          Contact:
                          <a :href="`mailto:${contact_email}`"
                            style="color: #ffffff"
                            ><strong>{{contact_name}}</strong></a
                          >, {{contact_title}}<br />
                          <br />
                          <strong>RCI</strong> Recourse Communications, Inc.<br />
                          112 Intracoastal Pointe Dr. | Jupiter, FL 33477 |
                          {{contact_phone}}<br />
                          <br />
                          <a
                            href="http://www.rciars.com"
                            style="color: #ffffff; text-decoration: none"
                            >www.<span style="color: #00acbc"
                              ><strong>r</strong></span
                            ><strong
                              ><span style="color: #92f354">c</span
                              ><span style="color: #00acbc">i</span>ars</strong
                            >.com</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- END: Inner Shell -->
                </td>
              </tr>
            </table>
          </div>
          <!-- END: Outer Shell -->
          <!-- Wide Table to Force Gmail App Auto-Fit Behavior -->
          <div style="visibility: hidden" class="Hide">
            <table
              width="900"
              cellpadding="0"
              cellspacing="0"
              border="0"
              class="MobFullWidth"
            ></table>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <!-- End of Template -->
</template>

<script>
/* eslint-disable */
export default {
  name: "Eprop",
  props: {
    contact_name: String,
    contact_title: String,
    contact_email: String,
    contact_phone: String,
    as_picked: String,
    as_tl_showcase: Number,
    as_addon_txt: Number,
    as_addon_call: Number,
    as_premier_post: Number,
    as_perfect_post: Number,
    as_video_premier_post: Number,
    as_video_perfect_post: Number,
    as_addon_perfect_assist: Number,
    ss_picked: String,
    ss_tl_pipeline: Number,
    rs_picked: String,
    rs_tl_recruit: Number,
    rs_jit_rpo: String,
    rs_pb_rpo: String,
    rs_fl_rpo: String,
    rs_container_search: String,
    rs_retained_search: String,
    rs_contingency_search: String,
    show_as: Boolean,
    show_ss: Boolean,
    show_rs: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.eprop {
  background-color: burlywood;
}
.topbar {
  background-color: rgb(71, 195, 211);
  color: #000;
  min-height: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/Eprop.vue